// A screen's heading, focused when the screen appears (I-1a Batch 4), so a screen
// reader starts reading the new step instead of staying on the old button.
// Screens are keyed per step, so this mounts once per step.

import { type ReactNode, useEffect, useRef } from 'react'

export function ScreenTitle({ children }: { readonly children: ReactNode }): React.JSX.Element {
  const ref = useRef<HTMLHeadingElement>(null)
  useEffect(() => {
    ref.current?.focus()
  }, [])
  return (
    <h1 ref={ref} tabIndex={-1} className="screen__title">
      {children}
    </h1>
  )
}
